// Refactored CustomCourseRequest.jsx — mobilfreundlich & klar strukturiert + dynamische Themenfilterung

import React, { useState, useEffect } from "react";
import CourseCard from "../components/CourseCard";
import ICONS from "../config/icon";
import Preloader from "../components/Preloader";
import { PaperBG } from "../kits";
import SeoHelmet from "./SeoHelmet";


import { generateCourseSchema } from "./utils/seoSchema";


// SEO
import { Helmet } from "react-helmet";



function normalizeDescription(desc) {
  if (Array.isArray(desc)) return desc;
  if (typeof desc === "string") {
    let str = desc.trim();
    // Versuche, den String als JSON zu parsen:
    try {
      const parsed = JSON.parse(str);
      if (Array.isArray(parsed)) return parsed;
    } catch (e) {}
    // Fallback: splitte an Kommas
    if (str.startsWith("[") && str.endsWith("]")) str = str.slice(1, -1);
    return str
      .split(",")
      .map(s => s.replace(/^"|"$/g, '').trim())
      .filter(Boolean);
  }
  return [String(desc)];
}

const generateSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};




// ...innerhalb deiner Komponente:



function Courses({ withPaper = true }) {
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, setError] = useState(null);
  const categoryParam = "all";

  const seoByCategory = {
  "2D": {
    title: "2D-Design-Kurse mit Illustrator, Photoshop & mehr",
    description: "Lerne 2D-Grafik mit echten Projekten – von Profis für Gestalter.",
  },
  "3D": {
    title: "3D-Kurse mit Blender & Cinema 4D",
    description: "Modelle, Renderings & Animation lernen – direkt am Praxisprojekt.",
  },
  Web: {
    title: "Web-Entwicklung lernen: HTML, CSS, React",
    description: "Vom Code zur Seite – Web-Kurse mit echten Resultaten.",
  },
  // ...
};

const seo = seoByCategory[categoryParam] || {
  title: "Alle Kurse – BITTER. Projektorientiert & Echt",
  description: "Wähle aus echten Kursprojekten für Medien, Web, 3D und Entwicklung.",

};

  useEffect(() => {
    fetch('https://www.denisbitter.de/stage01/api/get_courses.php')
      .then((response) => {
        if (!response.ok) throw new Error(`Fehler beim Laden der Kurse: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        if (!data.success || !Array.isArray(data.data)) throw new Error("Ungültige Kursdaten");
        const coursesWithSlugs = data.data.map((course) => ({
          ...course,
          slug: course.slug || generateSlug(course.title),
          description: normalizeDescription(course.description),
        }));

        setFilteredCourses(coursesWithSlugs);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fehler beim Abrufen der Kurse:", err.message);
        setError(err.message);
        setLoading(false);
      });
  }, []);



  if (loading) return <Preloader />;
  const defaultImage = "https://www.denisbitter.de/images/icons/default.png";
  const courseSchemas = filteredCourses.map((course) => generateCourseSchema(course));
  return (
    <>

 <SeoHelmet
  title={seo.title}
  description={seo.description}
  url="https://www.denisbitter.de/courses"
  image={defaultImage}
/>

 <Helmet>
  {courseSchemas.map((schema, index) => (
    <script key={index} type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  ))}
</Helmet>




      <section className="py-1 relative">
        {withPaper ? (
          <PaperBG className="py-10">
            <div className="container mx-auto px-6 text-center relative z-20">
              <div className="grid gap-8 grid-cols-1 lg:grid-cols-2">
                {filteredCourses.map((course) => (
                  <CourseCard
                    key={course.id}
                    course={course}
                    icon={ICONS[course.icon] || ICONS.default}
                    slug={course.slug}
                  />
                ))}
              </div>
            </div>
          </PaperBG>
        ) : (
          <div className="container mx-auto px-6 py-10 text-center relative z-20">
            <div className="grid gap-8 grid-cols-1 lg:grid-cols-2">
              {filteredCourses.map((course) => (
                <CourseCard
                  key={course.id}
                  course={course}
                  icon={ICONS[course.icon] || ICONS.default}
                  slug={course.slug}
                />
              ))}
            </div>
          </div>
        )}
      </section>

   </>
  );
}

export default Courses;
